import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'timeLeft'
})
export class TimeLeftPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    var result:string;
    var days = Math.floor (value / 86400);
    value -= days * 86400;
    var hours = Math.floor(value / 3600) % 24;
    value -= hours * 3600;
    var minutes = Math.floor(value / 60) % 60;
    value -= minutes * 60;
    var seconds = value % 60;
    result=((days>0)?days.toString()+' days, ':'') + ((hours<10)?'0':'') + hours + ':' + ((minutes<10)?'0':'') + minutes + ':' + ((seconds<10)?'0':'') + seconds + ':';
    return result;
  }
}